import React from 'react'
import styled from 'styled-components';
import ImageSection from '../Components/ImageSection';
import Title from '../Components/Title';
import {MainLayout} from '../styles/Layouts';
import Story from '../Components/Story';
//import ReviewsSection from '../Components/ReviewsSetion';
import Skills from '../Components/Skills';
import Resume from '../Components/Resume';

function AboutPage() {
    return (
        <MainLayout>
            <AboutStyled >
                <Title title={'About Me'} />
                <ImageSection />
                
                {/* <ReviewsSection /> */}
               

            </AboutStyled >
            <Skills />
            <Resume />
            <div className="service-1">
                    <Story />
            </div>
        </MainLayout>
    )
}

const AboutStyled = styled.section`
    
`;

export default AboutPage
